import { defineMessages } from "react-intl";

const messages = defineMessages({
    h2: {
        id: "landing.why.h2",
    },
    p: {
        id: "memory.landing.why.p",
    },
});

export default messages;
